<template>
    <div class="bb-avatar text-center">
        <img :src="user && user.avatar ? `/storage/${user.avatar}` : '/vendor/core/plugins/comment/images/avatar.png'" alt="avatar" class="img-circle h-100 w-100" />
    </div>
</template>

<script>

export default {
    name: 'Avatar',
    props: {
        user: {
            type: Object,
        }
    },
    methods: {

    },
    inject: ['data', 'changeAvatarUrl', 'setSoftLoading']
}
</script>
